/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';
import { GET_RECENT_ACTIVITY } from '../actions/ActivityActions';
import type { ActivityReducer } from '../types/activityTypes';
export const INIT_STATE: ActivityReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  recentActivities: [],
};
export function Handler(
  state: ActivityReducer = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
) {
  const { data } = action;

  switch (action.type) {
    case GET_RECENT_ACTIVITY.response:
      return { ...state, recentActivities: data, loadingStatus: LOADING_STATUS.LOADED };

    default:
      return state;
  }
}
const Activity = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_RECENT_ACTIVITY],
  resetOn: ['APP_CHANGE'],
});
export default Activity;
